/* eslint-disable */
import { Button, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_DOCKET_CALL_REPORT_ISSUE } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import deliveryDocketStyles from './DeliveryDocket.component.styles';

/**
 * DeliveryDocketReportIssue
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DeliveryDocketReportIssue = ({ actions, classes, onClose, open, isReporting, phoneNumber }) => {
  /**
   * Registers analytics UI event for call button click
   * @returns {void} void
   * @memberof DocketsList
   */
  const callHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketCallReportIssue`,
          phoneNumber,
        },
      },
      type: UI_DOCKET_CALL_REPORT_ISSUE,
    });
    return;
  };

  return (
    <Modal
      content={<Typography variant="body1">Issues with this docket can be reported by calling Boral</Typography>}
      footer={
        isReporting ? (
          <Grid container justify="flex-end">
            <Grid item>
              <Spinner size={20} loaderStyles={classes.spinner} />
            </Grid>
          </Grid>
        ) : (
          <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
            <Grid item>
              <Button onClick={callHandler} className={classes.button} color="primary" disabled={isReporting} href={`tel:${phoneNumber}`} variant="contained">
                Call {phoneNumber}
              </Button>
            </Grid>
            <Grid item>
              <Button className={classes.button} color="primary" disabled={isReporting} onClick={onClose} variant="outlined">
                Cancel
              </Button>
            </Grid>
          </Grid>
        )
      }
      paperClasses={classes.paperClasses}
      maxWidth="sm"
      icon={<PhoneIcon />}
      preventFullScreen
      onClose={onClose}
      open={!!open}
      rightHeading={null}
      title={
        <Grid container>
          <Grid item xs={12}>
            Call Boral
          </Grid>
        </Grid>
      }
    />
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
DeliveryDocketReportIssue.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.any.isRequired,
  isReporting: PropTypes.bool.isRequired,
  phoneNumber: PropTypes.string,
};

export default compose(
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(deliveryDocketStyles), { withTheme: true }),
)(DeliveryDocketReportIssue);
